
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  * 
  * The source file is located at:
  *   /codebuild/output/src2984367493/src/vl-app/pages/automated-clinician-dev.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Head from 'next/head';
import { AutomatedClinicianParticipant, PenpalParticipantBridge } from '../lib/automatedParticipant';

const AutomatedClinicianDev = () => {
  const { t } = useTranslation('common');
  useEffect(() => {
    const bridge = new PenpalParticipantBridge();
    const participant = new AutomatedClinicianParticipant({ bridge });

    bridge
      .connect({
        startSession: async () => {
          await participant.initialize();
        },
        stopSession: async () => {
          await participant.disconnect();
        }
      })
      .catch((error) => {
        console.error('[Clinician] Bridge connection failed:', error);
      });

    return () => {
      participant.disconnect().catch(() => {});
      bridge.disconnect().catch(() => {});
    };
  }, []);

  return (
    <Head>
      <title>{t('Automated Clinician')}</title>
      <style>{`
        body {
          margin: 0;
          padding: 0;
          width: 0;
          height: 0;
          overflow: hidden;
          visibility: hidden;
          opacity: 0;
          position: absolute;
          top: -9999px;
          left: -9999px;
        }
      `}</style>
    </Head>
  );
};

export default AutomatedClinicianDev;
export const Route = createFileRoute('/automated-clinician-dev')({ component: AutomatedClinicianDev });
